import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, ButtonGroup, Tooltip } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <LanguageIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
      <ButtonGroup size="small" variant="outlined">
        <Tooltip title={t('common.english')}>
          <Button
            onClick={() => changeLanguage('en')}
            variant={currentLanguage === 'en' ? 'contained' : 'outlined'}
            sx={{
              minWidth: 'auto',
              px: 1.5,
              fontWeight: currentLanguage === 'en' ? 'bold' : 'normal',
              backgroundColor: currentLanguage === 'en' ? 'primary.main' : 'transparent',
              color: currentLanguage === 'en' ? 'white' : 'text.primary',
              '&:hover': {
                backgroundColor: currentLanguage === 'en' ? 'primary.dark' : 'action.hover',
              }
            }}
          >
            EN
          </Button>
        </Tooltip>
        <Tooltip title={t('common.lithuanian')}>
          <Button
            onClick={() => changeLanguage('lt')}
            variant={currentLanguage === 'lt' ? 'contained' : 'outlined'}
            sx={{
              minWidth: 'auto',
              px: 1.5,
              fontWeight: currentLanguage === 'lt' ? 'bold' : 'normal',
              backgroundColor: currentLanguage === 'lt' ? 'primary.main' : 'transparent',
              color: currentLanguage === 'lt' ? 'white' : 'text.primary',
              '&:hover': {
                backgroundColor: currentLanguage === 'lt' ? 'primary.dark' : 'action.hover',
              }
            }}
          >
            LT
          </Button>
        </Tooltip>
      </ButtonGroup>
    </Box>
  );
};

export default LanguageSwitcher; 